export default {"src":"/_next/static/media/outdoor-play-area.47b3f50c.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};